import { defineComponent as _defineComponent } from 'vue'
import BCXForm from '@/components/molecules/forms/BCXForm.vue';
import { computed, PropType } from 'vue';
import { BcxFormField } from '@/models/BcxForm';
import useI18n from '@/mixins/useI18n';
import useResponsiveness from '@/mixins/useResponsiveness';
import { i18nToItemList } from '@/utils/selectItemTools';
import { useVModel } from '@vueuse/core';
import IconX from '@/components/svg/x-circle-2.svg?inline';


export default /*#__PURE__*/_defineComponent({
  __name: 'InvoicePositionsPosition',
  props: {
  nr: {
    type: Number,
    default: 0
  },
  position: {
    type: Object as PropType<any>,
    required: true
  }
},
  emits: ['update:position'],
  setup(__props, { emit }) {

const props = __props;



const { t } = useI18n();
const { isMobileWidth } = useResponsiveness();



const vmData = useVModel(props, 'position', emit);

const horizontalGap = isMobileWidth.value ? '16px' : '40px';
const verticalGap = isMobileWidth.value ? '32px' : '24px';

const fields = computed(() => {
  const isMobile = isMobileWidth.value;
  const fields:BcxFormField[] = [
    {
      name: 'amount',
      type: 'number',
      width: isMobile ? '50%' : '25%',
      label: `${t('invoice.positions.form.amount')}`,
      textOptions: {
        min: 1
      }
    },
    {
      name: 'unit',
      type: 'select',
      width: isMobile ? '50%' : '25%',
      options: i18nToItemList('invoice.positions.form.unitOptions').value ?? [],
      label: `${t('invoice.positions.form.unit')}`
    },
    {
      name: 'unitPrice',
      type: 'currency',
      width: isMobile ? '50%' : '25%',
      label: `${t('invoice.positions.form.unitPrice')}`,
      currencyOptions: {
        // @todo: use right currency
        symbol: '€'
      }
    },
    {
      name: 'netSum',
      type: 'plaintext',
      width: isMobile ? '50%' : '25%',
      label: `${t('invoice.positions.form.netSum')}`
    },
    {
      name: 'description',
      type: 'text',
      width: '100%',
      label: `${t('invoice.positions.form.description')}`
    }
  ];
  return fields;
});


return { __sfc: true,props, t, isMobileWidth, emit, vmData, horizontalGap, verticalGap, fields, BCXForm, IconX }
}

})